<div [formGroup]="dataForm">
  <div class="fx-layout-row fx-layout-align-space-between-m fx-layout-align-center-x">
    <div class="fx-layout-col fx-gap-10">
      <h3>Login Successful</h3>
      <h5>You have access to multiple companies, please select which company to manage:</h5>
    </div>
  </div>
  <div>
    <mat-form-field>
      <mat-label>Company</mat-label>
      <mat-select formControlName="companyContactId">
        @for (lookup of userContactsLookupData; track lookup.id) {
          <mat-option [value]="lookup.id" [disabled]="!lookup.data">
            {{ lookup.text }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (companyContactId.touched && companyContactId.errors?.required) {
      <mat-error> Company is required </mat-error>
    }
  </div>
  <div class="fx-layout-row fx-gap-5 fx-layout-align-space-between-m fx-layout-align-center-x">
    <div class="fx-flex-30 fx-align-center-y fx-align-center-x">
      <button mat-raised-button (click)="switchCompany()" [disabled]="dataForm.status !== 'VALID'" color="primary"> Continue </button>
    </div>
    <div class="fx-flex-80">
      <h6>You can always switch companies while logged in by clicking the profile icon at the top right.</h6>
    </div>
  </div>
  <div>
    @if (isError) {
      <mat-error> {{switchErrorMessage}} </mat-error>
    }
  </div>
</div>